import { Pane } from 'tweakpane'

let instance = null

export default class Debug {
  constructor() {
    if (instance) {
      return instance
    }

    instance = this
        
    this.active = window.location.hash === '#debug'

    if (this.active) {
      this.ui = new Pane()
      this.ui.containerElem_.style.zIndex = 999
      this.ui.containerElem_.style.position = 'fixed'

      this.ui.containerElem_.style.display = 'none'

      this.createParams()
    }
  }

  createParams() {
    this.params = {

    }
  }
}